import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Icon } from 'loyal-react'

import { CartItem } from '.'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

import '@loyal_template/cart.css'
import '@loyal_molecules/accordion.css'

class Cart extends Component {
  componentDidMount () {
    this.props.loadCart()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.onlyCash !== this.props.onlyCash) {
      this.props.loadCart()
    }
  }

  render () {
    const { items, price, priceCash } = this.props
    const count = items.length

    return (
      <div
        className={`cart zindex-high col-md-1 col-auto order-md-4 order-3 ${this.props.desktop && 'd-none d-sm-block '}`}
        aria-haspopup={count > 0}
      >
        <div className='row align-items-center h-100 justify-content-end justify-content-md-center'>
          <div className='col-auto pos-relative'>
            {count > 0 ? (
              <strong className='cart-count color-brand-6 d-block txt-center w-100 txt-font-body pos-absolute'>
                {count}
              </strong>
            ) : (
              ''
            )}
            <Link
              to='/cart'
              role='button'
              aria-label='Ir para o carrinho'
              tabIndex='0'
            >
              <Icon
                iconName='icon_cart'
                className='icon_only color-brand-5 cursor'
              />
            </Link>
          </div>
        </div>
        {count > 0 && window.innerWidth > 420 ? (
          <div className='resume-cart border-ui-3 bg-white radius py-2'>
            <div className='resume-header row mx-0 border-bottom border-color-ui-3 mx-0 px-2 pb-2'>
              <div className='col mr-auto px-0'>
                <Link
                  className='h3 txt-font-title txt-title color-title'
                  to='/cart'
                >
                  Ver carrinho
                </Link>
              </div>
              <div className='col-auto px-0'>
                <div className='row align-items-center h-100'>
                  <div className='col-12'>
                    <Icon iconName='icon_right' className='icon-sm' />
                  </div>
                </div>
              </div>
            </div>
            <div className='resume-body'>
              <div className='panel-accordion active border-color-ui-3  pl-2 pr-1 py-1 bg-white'>
                <div className='panel-scroll'>
                  <div className='row mx-0'>
                    <div className='col-12 px-0 '>
                      {count > 0 ? (
                        items.map((item, index) => (
                          <CartItem key={index} {...item} />
                        ))
                      ) : (
                        <div className='cart-item row mx-0 pr-1'>
                          <div className='cart-product-info col'>
                            <div className='cart-product-info row'>
                              <div className='product-infos col-12 mx-0'>
                                <p className='txt-body-sm'>
                                  Você não possui produtos no carrinho
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='resume-footer row mx-0 border-top border-color-ui-3 mx-0 px-2 pt-2'>
              <div className='col mx-0 mr-auto'>
                <h3 className='txt-font-body txt-body-sm color-brand-1'>
                  Subtotal:
                </h3>
              </div>
              <div className='col-auto'>
                <h3 className='txt-font-body txt-body-sm color-brand-1'>
                  <CatalogCurrencyLabel
                    price={{ points: price, cash: priceCash }}
                    checkCashOnly
                  />
                </h3>
              </div>
              {count > 0 && (
                <div className='col-12 px-0 mt-1'>
                  <Link
                    className='btn btn-sm d-block btn-featured txt-button txt-center txt-font-body'
                    to='/checkout'
                  >
                    { this.props.onlyCash ? 'Comprar Agora' : 'Resgatar Agora' }
                  </Link>
                </div>
              )}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}

Cart.propTypes = {
  items: PropTypes.array.isRequired,
  onlyCash: PropTypes.bool,
  price: PropTypes.number.isRequired,
  priceCash: PropTypes.number.isRequired,
  loadCart: PropTypes.func.isRequired,
  desktop: PropTypes.bool
}

export default Cart



// WEBPACK FOOTER //
// ./src/App/Header/Cart/Cart.js